/**
 * Created by Ning Jiang on 2021-06-23.
 */

import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {ReelState} from "../../core/reel/ReelState";
import {Serial} from "../Serial";
import {BelowStakeWinRestriction} from "../server/BelowStakeWinRestriction";

export class SerialNormalIdlePresentation implements FlowStatePresentation {

    constructor() {}

    public start(flowStateController:FlowStateController) {
        flowStateController.setSkipCallback(() => this.skip(flowStateController));

        Serial.reels.forEach((reel) => {
            reel.reelState = ReelState.IDLE;
        });

        Serial.xBetController.buttonsVisible = true;
        if(!Serial.autoPlayPlugin.isAutoplayRound) {
            Serial.xBetController.featureEnabled = true;
            Serial.xBetController.startIdle();
        }

        if(!Serial.model.parsedGameData) {
            // game init idle.
            return;
        }
        if(Serial.model.parsedGameData.nextMode != GameMode.NORMAL) {
            this.finishState(flowStateController);
            return;
        }

        if(!BelowStakeWinRestriction.isWinBelowPlayedBetValue()) {
            Serial.individualWin.start();
        }
    }

    private async skip(flowStateController:FlowStateController):Promise<any> {
        await Serial.individualWin.stop();
        this.finishState(flowStateController);
    }

    private finishState(flowStateController:FlowStateController):void {
        Serial.xBetController.stopIdle();
        flowStateController.finish();
    }
}